<template>
  <div
    ref="modal"
    class="cs-modal-overlay"
    :class="{
      'cs-modal-overlay-showed': visible
    }"
    :style="{
      top: `${topPosition}px`,
      bottom: `${bottomPosition}px`,
      backgroundColor: colorOverlay,
      alignItems: `${contentPosition}`
    }"
    @click.self="close"
  >
    <div class="cs-modal">
      <slot name="content-wrapper">
        <div v-if="$slots.hasOwnProperty('header')" class="cs-modal-header">
          <slot name="header" />
        </div>

        <slot name="body">
          <div class="cs-modal-body">
            <slot />
          </div>
        </slot>
      </slot>
    </div>
  </div>
</template>

<script>
import { inArray } from 'lib/component/validators';

export default {
  props: {
    value: {
      type: Boolean,
      default() {
        return false;
      },
    },
    colorOverlay: {
      type: String,
      default() {
        return '';
      },
    },
    contentPosition: {
      type: String,
      validator: inArray(['flex-start', 'center', 'flex-end']),
      default() {
        return 'center';
      },
    },
  },
  data() {
    return {
      visible: false,
      topPosition: 0,
      bottomPosition: 0,
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.visible = val;
      },
    },
    visible: {
      handler(val) {
        const modal = this.$refs.modal;
        this.$emit('input', val);

        if (val) {
          document.body.appendChild(modal);
          document.body.style.overflowY = 'hidden';

          this.setPosition();
        } else {
          document.body.style.overflowY = 'unset';

          modal.remove();
        }
      },
    },
  },
  methods: {
    close() {
      this.visible = false;
    },
    setPosition() {
      const pageYOffset = window.pageYOffset;

      this.topPosition = pageYOffset;
      this.bottomPosition = -pageYOffset;
    },
  },
};
</script>

<style lang="sass" scoped>
  .cs-modal
    display: flex
    flex-direction: column
    align-items: center
    position: relative

    &-overlay
      position: absolute
      top: 0
      right: 0
      bottom: 0
      left: 0
      z-index: 5000
      display: none
      align-items: center
      justify-content: center
      overflow: hidden

      &-showed
        display: flex

    &-header
      height: 40px
      border-bottom: 1px solid #d7d8d9
      padding: 0 40px 0 20px
      left: 0
      display: flex
      align-items: stretch

    &-body
      padding: 10px 20px

    &-close
      position: absolute
      top: 0
      right: 0
      padding: 6px
      z-index: 4000
</style>
